(() => {
  if (window.EfeHalloweenMotion) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const pendingKey = 'efestore-halloween-next-page-v1';
  const entryKey = 'efestore-halloween-entry-v6';
  let layer;
  let cleanupTimer;
  let navigationTimer;
  let navigating = false;

  function enabled() {
    return !reduced.matches && document.querySelector('[data-hw-root]')?.dataset.motion !== 'false';
  }
  function clear() {
    clearTimeout(cleanupTimer);
    layer?.replaceChildren();
  }
  function flight(count = 12) {
    if (!layer || !enabled()) return;
    clear();
    const narrow = window.innerWidth < 750;
    const total = narrow ? Math.min(count, 9) : count;
    const fragment = document.createDocumentFragment();
    for (let index = 0; index < total; index++) {
      const bat = document.createElement('span');
      bat.className = 'hw-page-bat';
      const image = document.createElement('img');
      image.src = layer.dataset.batUrl;
      image.alt = '';
      image.width = 480;
      image.height = 240;
      bat.style.setProperty('--x', `${(index / total) * 103 - 8 + Math.random() * 10}%`);
      bat.style.setProperty('--size', `${(narrow ? 62 : 82) + Math.random() * (narrow ? 65 : 104)}px`);
      bat.style.setProperty('--duration', `${.75 + Math.random() * .24}s`);
      bat.style.setProperty('--delay', `${Math.random() * .12}s`);
      bat.style.setProperty('--drift', `${Math.random() * 210 - 105}px`);
      bat.style.setProperty('--tilt', `${Math.random() * 32 - 16}deg`);
      bat.append(image);
      fragment.append(bat);
    }
    layer.append(fragment);
    cleanupTimer = setTimeout(clear, 1250);
  }
  function remember(destination) {
    try { sessionStorage.setItem(pendingKey, JSON.stringify({ destination, at: Date.now() })); } catch (_) {}
  }
  function enter(restored = false) {
    navigating = false;
    clearTimeout(navigationTimer);
    clear();
    let pending;
    let first = false;
    try {
      pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null');
      sessionStorage.removeItem(pendingKey);
      first = !sessionStorage.getItem(entryKey);
      sessionStorage.setItem(entryKey, '1');
    } catch (_) { first = true; }
    if (!enabled() || window.Shopify?.designMode) return;
    const fresh = pending && Date.now() - pending.at < 15000;
    if (!restored && !first && !fresh && !document.referrer.startsWith(location.origin)) return;
    const image = new Image();
    image.onload = () => { if (document.visibilityState !== 'hidden' && !navigating) flight(restored ? 10 : 13); };
    image.src = layer.dataset.batUrl;
  }
  function safeLink(link, event) {
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return null;
    if (link.hasAttribute('download') || (link.target && link.target !== '_self') || link.hasAttribute('data-no-hw-transition')) return null;
    let url;
    try { url = new URL(link.href, location.href); } catch (_) { return null; }
    if (url.origin !== location.origin || !['http:', 'https:'].includes(url.protocol)) return null;
    // Checkout and customer-account links retain their immediate native behaviour.
    if (/\/(?:checkout|checkouts|account)(?:\/|$)/.test(url.pathname)) return null;
    return url;
  }
  function ambient() {
    if (!enabled() || window.Shopify?.designMode || !document.querySelector('[data-hw-root]')) return;
    const sky = document.createElement('div');
    sky.className = 'hw-ambient';
    sky.setAttribute('aria-hidden', 'true');
    for (let i = 0; i < 4; i++) {
      const bat = document.createElement('span');
      bat.className = 'hw-ambient-bat';
      bat.style.setProperty('--height', `${12 + i * 21}%`);
      bat.style.setProperty('--size', `${42 + i * 9}px`);
      bat.style.setProperty('--delay', `${2 + i * 3}s`);
      const image = document.createElement('img');
      image.src = layer.dataset.batUrl;
      image.alt = '';
      image.width = 90;
      image.height = 45;
      bat.append(image);
      sky.append(bat);
    }
    document.body.append(sky);
    const remove = () => sky.remove();
    setTimeout(remove, 36000);
    reduced.addEventListener('change', remove, { once: true });
    window.addEventListener('pagehide', remove, { once: true });
  }
  function init() {
    layer = document.querySelector('[data-hw-page-flight]');
    if (!layer) return;
    ambient();
    document.addEventListener('click', event => {
      const link = event.target.closest?.('a[href]');
      const url = safeLink(link, event);
      if (!url || !enabled()) return;
      const samePage = url.pathname === location.pathname && url.search === location.search;
      if (samePage) {
        if (url.hash && url.hash !== location.hash) flight(7);
        return;
      }
      if (window.Shopify?.designMode) return;
      event.preventDefault();
      if (navigating) return;
      navigating = true;
      remember(url.href);
      flight(11);
      navigationTimer = setTimeout(() => location.assign(url.href), 190);
    });
    document.addEventListener('submit', event => {
      if (event.defaultPrevented || !enabled()) return;
      const form = event.target;
      if (form instanceof HTMLFormElement && /\/localization\/?$/.test(new URL(form.action, location.href).pathname)) {
        remember('localization');
        flight(9);
      }
    });
    window.addEventListener('pageshow', event => enter(event.persisted));
    window.addEventListener('pagehide', () => { clear(); clearTimeout(navigationTimer); navigating = false; });
    reduced.addEventListener('change', () => { if (reduced.matches) clear(); });
    if (document.readyState === 'complete') enter();
  }
  window.EfeHalloweenMotion = { flight, enabled };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();

